import { render, staticRenderFns } from "./PPMFilters2.vue?vue&type=template&id=0c6ba536"
import script from "./PPMFilters2.vue?vue&type=script&lang=ts"
export * from "./PPMFilters2.vue?vue&type=script&lang=ts"
import style0 from "./PPMFilters2.vue?vue&type=style&index=0&id=0c6ba536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports